module.exports = __webpack_public_path__ + "img/Blue_Mixed.4a496c27.png";